import { mainApi } from './index';
import type { ReferralsResponse, ReferralsTableParams } from '@/features/referrals/types/referrals.types';
import type { ReferralsAnalyticsResponse } from '@/features/referrals/types/analytics.types';

export const referralsApi = {
    /**
     * Fetch referrals table data
     */
    async getReferralsTable(params: ReferralsTableParams = {}): Promise<ReferralsResponse> {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        // Transform filter values to the format expected by the API
        const transformedFilters =
            params.filter_array?.map(filter => ({
                fieldName: filter.id,
                operator: filter.operator === 'li' ? 'like' : filter.operator,
                value: filter.value,
                type: filter.type,
                urlCode: filter.operator,
            })) ?? [];

        const queryParams = {
            page: params.page ?? 1,
            pageSize: params.pageSize ?? 10,
            sortCol: params.sortCol ?? 'created_at',
            sortDir: params.sortDir ?? 'desc',
            timezone: params.timezone ?? timezone,
            exclude_inactive: params.exclude_inactive ?? 0,
            filter_array: JSON.stringify(transformedFilters),
        };

        const { data } = await mainApi.get<ReferralsResponse>('v1/referrals/table', {
            params: queryParams,
        });

        return data;
    },

    /**
     * Fetch referrals analytics data
     */
    async getReferralsAnalytics(timezone?: string): Promise<ReferralsAnalyticsResponse> {
        const queryParams = {
            timezone: timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
        };

        const { data } = await mainApi.get<ReferralsAnalyticsResponse>('v1/referrals/graph', {
            params: queryParams,
        });

        return data;
    },
};
